module.exports = __webpack_public_path__ + "static/media/flatBedTruck_purple.3384fabf.svg";